"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const constants_1 = require("@/pages/ApprovedFeedstock/constants");
const style_1 = require("@/pages/ApprovedFeedstock/style");
const SELECT_OPTIONS = [
    "approved",
    "not_approved",
    "approved_with_restrictions",
    "homologated",
    "on_homologation"
];
const StatusSelectInput = ({ id, form }) => {
    return (react_1.default.createElement(material_1.FormControl, null,
        react_1.default.createElement(material_1.Select, { id: id, name: id, onBlur: form?.handleBlur, onChange: (event) => form?.setFieldValue(id, event.target.value), value: form?.values[id], input: react_1.default.createElement(style_1.StyledInputBase, null), renderValue: (value) => react_1.default.createElement(material_1.MenuItem, { value: value }, constants_1.ICONS_MAP.get(value)) }, SELECT_OPTIONS.map((option) => (react_1.default.createElement(material_1.MenuItem, { key: `${id}-${option}`, value: option },
            constants_1.ICONS_MAP.get(option),
            react_1.default.createElement(material_1.Typography, { sx: { marginLeft: "10px" } }, constants_1.LABELS_MAP.get(option))))))));
};
exports.default = StatusSelectInput;
